import { CampaignBody, CampaignResponse, OperationIds } from '../../../../API';
import { useCampaignsAPI } from '../../../../hooks/API/Payments/useCampaignsAPI';
import { CreateDataManager, DataManagerHookReturnType, DataManagerStateFullReturnType } from '../../../DataManager';

export type CampaignsDataManagerType = {
  state: DataManagerStateFullReturnType<CampaignResponse, CampaignBody>;
  hook: DataManagerHookReturnType<CampaignResponse, CampaignBody>;
};

const generateNew = (): CampaignBody => ({
  sponsorId: '',
  startDate: '',
  endDate: '',
  contentIds: [],
  countries: [],
  trackingUrl: ''
});

export const CampaignsDataManager = CreateDataManager<CampaignResponse, CampaignBody>({
  name: 'campaigns',
  idField: 'id',
  isVersionedEntity: false,
  useApiHook: useCampaignsAPI,
  generateNew,
  useUpdateForCreate: true,
  operationIdGetAll: OperationIds.GET_PAGINATED,
  toString: (campaign: CampaignBody | CampaignResponse) => campaign.sponsorId
});
